<template>
  <div id="footer">
    <!-- 商务联系请咨询 -->
    <div id="business">
      <div
        class="business_container"
        data-wow-duration="1.5s"
        data-wow-delay="0.5s"
      >
        <div class="business_box">
          <div class="business_box_title">
            <div class="bigDataBox">
              <img
                @dragstart.prevent
                style="height: 32px; padding: 4px 10px 0 0px"
                src="@/assets/img/Group.png"
                alt=""
              />
              <div
                style="
                  font-size: 28px;
                  height: 34px;
                  font-weight: 500；color：black;
                  letter-spacing: 8px;
                "
              >
                商务咨询请联系
              </div>
            </div>
            <div style="color: #7c7c7c">
              留下您的联系方式，我们的营销顾问免费为您服务
            </div>
          </div>
          <div class="form_box">
            <div class="form">
              <div class="form_container col-sm-2">
                <div class="relation_box">
                  <div class="relation_box_item">
                    <img
                      @dragstart.prevent
                      src="@/assets/img/phone.png"
                      alt=""
                    />
                    <div style="margin-left: 10px">021-60410579</div>
                  </div>
                  <div class="relation_box_item">
                    <img
                      @dragstart.prevent
                      src="@/assets/img/email.png"
                      alt=""
                    />
                    <div style="margin-left: 10px">king@kingcer.net</div>
                  </div>
                </div>
                <el-form
                  label-position="top"
                  label-width="auto"
                  :model="formLabelAlign"
                  style="max-width: 600px"
                >
                  <el-form-item label="姓名*">
                    <el-input v-model="formLabelAlign.name" />
                  </el-form-item>
                  <el-form-item label="联系方式*">
                    <el-input v-model="formLabelAlign.region" />
                  </el-form-item>
                  <el-form-item label="公司名称*">
                    <el-input v-model="formLabelAlign.type" />
                  </el-form-item>
                  <el-form-item label="所在省市*" prop="region">
                    <!-- <el-select
                      style="width: 100%"
                      v-model="formLabelAlign.region"
                      placeholder="Activity zone"
                    >
                      <el-option label="Zone one" value="shanghai" />
                      <el-option label="Zone two" value="beijing" />
                    </el-select> -->

                    <el-cascader
                      v-model="value"
                      :options="options"
                      :props="cascaderProps"
                      @change="handleChange"
                      style="width: 100%"
                    />
                  </el-form-item>
                </el-form>
                <el-button type="primary"
                  >预约顾问咨询<i
                    class="el-icon-arrow-right el-icon-arrow-right"
                  ></i
                ></el-button>
                <!-- <div>
                  <div>预约顾问咨询</div>
                  <img src="@/assets/img/Left.png" alt="" />
                </div> -->
              </div>
            </div>
            <div class="map col-sm-12">
              <img @dragstart.prevent src="@/assets/img/map.png" alt="" />
            </div>
            <!-- <img src="@/assets/img/产品服务模块.png" alt="" /> -->
          </div>
        </div>
      </div>
    </div>

    <div class="footer_box">
      <div class="footer_box_img">
        <img
          @dragstart.prevent
          style="width: 260px"
          src="@/assets/img/kcLogo.png"
          alt="logo图"
        />
      </div>
      <div class="footer_box_webImg">
        <div class="footer_container">
          <h1 class="footer_container_title">{{ mapList.title }}</h1>
          <div
            class="footer_container_item"
            @click="goMap(item.href)"
            v-for="(item, index) in mapList.itemList"
            :key="index"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <div class="footer_box_webImg">
        <div class="footer_container">
          <h1 class="footer_container_title">{{ productList.title }}</h1>
          <div
            class="footer_container_item"
            v-for="(item, index) in productList.itemList"
            :key="index"
            @click="goOut(item.href)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <div class="footer_box_webImg">
        <div class="footer_container">
          <h1 class="footer_container_title">{{ relationList.title }}</h1>
          <div
            class="footer_container_item"
            v-for="(item, index) in relationList.itemList"
            :key="index"
          >
            <img @dragstart.prevent :src="item.icon" alt="" />
            <div>{{ item.title }}</div>
          </div>
        </div>
        <!-- <img
          @dragstart.prevent
          style="width: 130px"
          :src="relationList.erweima"
          alt=""
        /> -->
      </div>
    </div>
    <div class="banquan">
      © Kingcer
      2024上海群盈网络科技有限公司版权所有，并保留所有权利&nbsp;&nbsp;&nbsp;&nbsp;
      <a href="https://beian.miit.gov.cn/">沪ICP备2025124759号-1</a
      >&nbsp;&nbsp;&nbsp;&nbsp; 本站支持&nbsp; IPV6
    </div>
    <!-- <div class="logo">
      <img src="@/assets/img/kcLogo.png" alt="logo图" />
    </div> -->
    <!-- <p class="title">{{ config.name }}</p>
    <p class="address_tel_fax">
      <span>地址：{{ config.address }}</span>
      <span>Tel：{{ config.phone }}</span>
      <span>Fax：{{ config.tel }}</span>
    </p>
    <p class="email_wx">
      <span>邮箱：{{ config.email }}</span>
      <span>公司微信号：{{ config.wechat }}</span>
    </p>
    <p class="copy">
      Copyright &copy; 2020 - 2022 {{ config.keepOnRecordIcp }}
      {{ config.name }}
    </p> -->
  </div>
</template>
<script>
import config from "@/config";
import provideData from "../../config/provice";
export default {
  name: "Footer",

  data() {
    return {
      options: [],
      formLabelAlign: {
        name: "",
        region: "",
        type: "",
      },
      config: config,
      cascaderProps: {
        expandTrigger: "hover",
        value: "value",
        label: "text",
        children: "children",
        checkStrictly: true,
      },
      value: "",
      mapList: {
        title: "网站地图",
        itemList: [
          {
            title: "产品介绍",
            href: "/software/newMedia",
          },
          {
            title: "案例",
            href: "/service",
          },
          {
            title: "新闻资讯",
            href: "/newsinformation",
          },
          {
            title: "关于我们",
            href: "/aboutUs",
          },
          {
            title: "联系我们",
            href: "/contactus",
          },
        ],
      },
      productList: {
        title: "产品链接",
        itemList: [
          {
            title: "今日头条",
            href: "https://www.toutiao.com/",
          },
          {
            title: "抖音短视频",
            href: "https://www.douyin.com/",
          },
          {
            title: "西瓜视频",
            href: "https://www.ixigua.com/",
          },
          {
            title: "火山小视频",
            href: "https://www.huoshanzhibo.com/",
          },
          {
            title: "懂车帝",
            href: "https://www.dongchedi.com/",
          },
          {
            title: "穿山甲",
            href: "https://www.csjplatform.com/",
          },
        ],
      },
      relationList: {
        title: "联系我们",
        erweima: require("@/assets/img/gongzhonghao.png"),
        itemList: [
          {
            icon: require("@/assets/img/phone_1.png"),
            title: "联系电话：021-61600119",
            href: "",
          },
          {
            icon: require("@/assets/img/position.png"),
            title: "地址：上海市浦东新区杨新东路24号",
            href: "",
          },
          {
            icon: require("@/assets/img/email_1.png"),
            title: "邮箱：king@kingcer.net",
            href: "",
          },
        ],
      },
    };
  },
  mounted() {
    console.log("provideData", provideData);
    this.options = provideData.provideData;
  },
  methods: {
    handleChange(value) {
      console.log(value);
    },
    goOut(url) {
      console.log("url", url);
      window.open(`${url}`);
    },
    goMap(item) {
      console.log("item", item);
      this.$router.push(`${item}`);
    },
  },
};
</script>
<style scoped>
.banquan {
  height: 60px;
  line-height: 60px;
  background-color: #111928;
}
.business_container {
  background: #fff !important;
}
.footer_box_img {
  display: flex;
  align-items: center;
}
@media screen and (max-width: 768px) {
  #business .business_box {
    width: 90% !important;

    /* background: url("../assets/img/bg_dot.png") 0 0 no-repeat; */
  }
  #business .business_box_title {
    width: 100% !important;
  }
  .form_box {
    flex-direction: column !important;
  }
  .footer_box {
    /* text-align: left; */
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    /* width: 75%;
  margin: 50px auto; */
  }
  .footer_box_img {
    width: 100%;
  }
  .footer_box_img img {
    width: 130px;
  }
  .banquan {
    padding: 0 20px;
    height: 60px;
    line-height: 30px;
    background-color: #111928;
  }
}
.footer_box {
  text-align: left;
  display: flex;
  justify-content: space-between;
  width: 75%;
  margin: 50px auto;
}
.footer_container_title {
  font-size: 25px;
}
.footer_container_item {
  display: flex;
  justify-content: flex-start;
  align-content: center;
}
.footer_container_item img {
  padding-right: 5px;
}
.footer_container_item {
  color: #d3d3d3;
  padding: 14px 0;
  cursor: pointer;
}
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #333333;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}

/* 商务联系 */
#business {
  color: black;
  background-size: 100% 100%;
  transition: all ease 0.6s;
}

#business .business_box {
  width: 75%;
  display: flex;
  flex-direction: column;
  position: relative;
  padding-bottom: 14vh;
  margin: 0 auto;

  /* background: url("../assets/img/bg_dot.png") 0 0 no-repeat; */
}
#business .business_box_title {
  display: flex;
  flex-direction: column;
  width: 75%;
  margin: 50px 0px 50px 0px;
  text-align: left;
}
#business .bigDataBox {
  display: flex;
  justify-content: left;
  align-items: center;
  padding: 2vh 0;
}
#business .form_box {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.form_box .form {
  width: 100%;
  text-align: left;
}
.form_container {
  width: 100% !important;
}
.map {
  width: 100% !important;
  padding: 20px 0 0 0 !important;
}
.relation_box {
  display: flex;
  justify-content: space-between;
  padding-bottom: 20px;
}
.relation_box .relation_box_item {
  display: flex;
  width: 50%;
  justify-content: flex-start;
  align-items: center;
}
.map img {
  width: 100%;
}
.form .form_container {
  width: 80%;
  padding-left: 0 !important;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue